import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";

const FooterNav = ({ className, ...props }) => {
  const classes = classNames("footer-nav", className);

  return (
    <nav {...props} className={classes}>
      <ul className='list-reset'>
        {/* <li>
          <Link to="#0">Contact</Link>
        </li>
        <li>
          <Link to="#0">About us</Link>
        </li>
        <li>
          <Link to="#0">FAQ's</Link>
        </li>
        <li>
          <Link to="#0">Support</Link>
        </li> */}
        <h6
          id='contact'
          style={{ alignContent: "right", justifyContent: "right" }}>
          Medhavimatrix@gmail.com <br></br>
          {"+91 966-7999-744"}
        </h6>
      </ul>
    </nav>
  );
};

export default FooterNav;
